import React, { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefIncidents from "table-defs/TableDefIncidents";
import ReactDOM from "react-dom";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";

import {
    loadIncidentsAction,
    deleteIncidentAction,
    loadSitesAction,
    approveIncidentAction,
    completeIncidentAction,
    notifyIncidentAction,
    setPaginationAction,
    investigationIncidentAction,
    loadIncidentTypesAction,
    loadAffiliatesAction,
} from "store/actions/Actions";

import useFilterRows from "helpers/customHooks/useFilterRows";

import { setSelectedRows, toggleDropdowns, exportAsCSV } from "helpers/utils";

const Incidents = props => {
    const dispatch = useDispatch();
    const DatatableReducer = useSelector((state) => state.DatatableReducer);

    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: []
    });

    const {
        loadSitesAction,
        completeIncidentAction,
        loadIncidentsAction,
        approveIncidentAction,
        setPaginationAction,
        loadIncidentTypesAction,
        SitesReducer,
        IncidentsReducer,
        IncidentTypesReducer,
        investigationIncidentAction,
        deleteIncidentAction,
        notifyIncidentAction,
        UserOrgSiteReducer,
        AffiliatesReducer,
        loadAffiliatesAction,
    } = props;

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    useEffect(() => {
        loadAffiliatesAction && loadAffiliatesAction();
    }, [loadAffiliatesAction]);

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!IncidentTypesReducer.incidentTypes) {
            loadIncidentTypesAction();
        }
    }, [IncidentTypesReducer.incidentTypes, loadIncidentTypesAction]);

    useEffect(() => {
        if (!IncidentsReducer.incidents && SitesReducer.sites && IncidentTypesReducer.incidentTypes) {
            loadIncidentsAction();
        }
    }, [IncidentsReducer.incidents, loadIncidentsAction, IncidentTypesReducer.incidentTypes, SitesReducer.sites]);

    // ##############################################

    const [activeReg, setActiveReg] = useState('');

    useEffect(() => {
        if (DatatableReducer.datatable && DatatableReducer.datatable.dashboard && DatatableReducer.datatable.dashboard.activeReg) {
            setActiveReg(DatatableReducer.datatable.dashboard.activeReg);
        }
    }, [DatatableReducer.datatable]);

    useEffect(() => {
        if (activeReg) {
            setFilters({
                ...DatatableReducer.datatable.incidents.filters,
                regulatory_act: activeReg,
            });
        }
    }, [activeReg]);

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        regulatory_act: activeReg,
        selected_sites: [],
        dateField: "occurred"
    };

    const [filters, setFilters] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.incidents && DatatableReducer.datatable.incidents.filters)
        ? DatatableReducer.datatable.incidents.filters
        : noFilters);


    const [selectedIncidentIds, setSelectedIncidentIds] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.incidents && DatatableReducer.datatable.incidents.selectedIds)
            ? DatatableReducer.datatable.incidents.selectedIds
            : []);

    useEffect(() => {
        dispatch({
            type: 'SET_DATATABLE',
            payload: {
                datatable: {
                    incidents: {
                        selectedIds: selectedIncidentIds,
                        filters,
                        selectedRows: state.selectedRows,
                        selected_sites: state.selected_sites,
                        rowsPerPage: (DatatableReducer.datatable && DatatableReducer.datatable.incidents && DatatableReducer.datatable.incidents.rowsPerPage)
                        ? DatatableReducer.datatable.incidents.rowsPerPage
                        : 10,
                        currentPage: (DatatableReducer.datatable && DatatableReducer.datatable.incidents && DatatableReducer.datatable.incidents.currentPage)
                        ? DatatableReducer.datatable.incidents.currentPage
                        : 0
                    },
                },
            },
        });
    }, [selectedIncidentIds, filters, state]);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
        setPaginationAction({ dataType: 'incidents', currentPage: 0 });
    };

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
        setPaginationAction({ dataType: 'incidents', currentPage: 0 });
    };

    const filteredRows = useFilterRows(filters, IncidentsReducer.incidents);

    // ##############################################

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({
                ...s,
                selectedRows
            }));
        }
    };

    // const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) || false;
    const is_officer = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) || false;
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    const chooseActionDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const regDropdownRef = React.createRef();

    const openAddNewIncident = () => props.history.push("/maintain/incidents/add-new-incident");

    const labels = () => (
        {
          name: {
            label: 'TITLE',
          },
          description: {
            label: 'DESCRIPTION',
          },
          regulatory_act: {
            label: 'REGULATORY',
          },
          occurred: {
            label: 'OCCURRED',
          },
          discovered: {
            label: 'DISCOVERED',
          },
          reported: {
            label: 'REPORTED',
          },
          siteName: {
            label: 'SITE',
          },
          resolved: {
            label: 'RESOLVED',
          },
          reported_by: {
            label: 'REPORTED BY'
          },
          affiliate: {
            label: 'AFFILIATE',
          },
          typeText: {
            label: 'TYPE',
          },
          affected: {
            label: 'AFFECTED',
          },
          investigating: {
            label: 'STATUS',
          }
        }
    );

    return (
        <AppLayoutWrapFull onClick={toggleDropdowns([chooseActionDropdownRef, statusDropdownRef, siteDropdownRef, regDropdownRef])}>
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD INCIDENT"
                    primaryButtonHandler={openAddNewIncident}
                    searchHandler={e => {
                        setFilters({ ...filters, text: e.target.value || "" });
                        setPaginationAction({ dataType: 'incidents', currentPage: 0 });
                    }}
                    searchValue={filters.text}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={
                        (is_officer || is_super) ? [
                        {
                            actionName: "Under Investigation Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    investigationIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Verify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    approveIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Complete Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    completeIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    notifyIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Export Selected",
                            actionHandler: () => {
                                const data = IncidentsReducer.incidents.filter((item) => selectedIncidentIds.map(i => i.id).includes(item.id));
                                const updatedData = data.map((item) => {
                                    const affiliate = AffiliatesReducer && AffiliatesReducer.affiliates.find((affiliate) => affiliate.id === item.affiliate);
                                    let investigatingStr = '';
                                    switch (item.investigating) {
                                        case '0':
                                            investigatingStr = 'Not Verified';
                                            break;
                                        case '1':
                                            investigatingStr = 'Under Investigation';
                                            break;
                                        case '2':
                                            investigatingStr = 'Verified';
                                            break;
                                        case '3':
                                            investigatingStr = 'Completed';
                                            break;
                                        default:
                                            investigatingStr = 'Unknown';
                                            break;
                                    }
                                    return {
                                        ...item,
                                        affected: item.affected ? 'Yes' : 'No',
                                        investigating: investigatingStr,
                                        affiliate: affiliate && affiliate.name
                                    }
                                })
                                exportAsCSV(updatedData, labels, 'incidents.csv');
                            }
                        },
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => {
                                    
                                const idCount = selectedIncidentIds.length;

                                if (idCount > 0) {
                                    setShowConfirmModal({
                                        title: 'Delete selected incidents',
                                        question: idCount === 1 ? 
                                            `Are you sure you want to delete the selected incident?` : 
                                            `Are you sure you want to delete ${idCount} selected incidents?`,
                                        confirmAction: () => {
                                            deleteIncidentAction(selectedIncidentIds);
                                        },
                                    });
                                } else {
                                    setShowConfirmModal({
                                        type: 'simple',
                                        title: 'Nothing selected',
                                        question: `Please select incidents to be deleted.`,
                                    });
                                }
                            }
                        }
                    ]
                    :
                    [
    
                        {
                            actionName: "Under Investigation Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    investigationIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Verify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    approveIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    notifyIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                    ]
                    }
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                                setPaginationAction({ dataType: 'incidents', currentPage: 0 });
                            }
                        },
                        sites: SitesReducer.sites ? SitesReducer.sites.map(site => {
                            return {
                                id: site.id,
                                siteName: site.name,
                                value: filters.selected_sites.includes(site.id) ? true : false
                            }
                        }) : [],
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "Not Verified", "Under Investigation", "Verified", "Completed"],
                    }}
                    statusDropdownRef={statusDropdownRef}
                    reg={{
                        onChange: setFilter("regulatory_act"),
                        options: ["All regulatory", "HIPAA", "OSHA"]
                    }}
                    regDropdownRef={regDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                        setPaginationAction({ dataType: 'incidents', currentPage: 0 });
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {IncidentsReducer.incidents &&
                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefIncidents}
                    dataType="incidents"
                    onChangeRowSelect={({ selectedRows }) => onChangeRowSelect({ selectedRows })}
                    customTableProps={
                        (is_officer || is_super) ? {
                            selectedRows: state.selectedRows ? state.selectedRows : selectedIncidentIds,
                            viewIncident: id => {
                                props.history.push(`/maintain/incidents/edit?id=${id}`);
                            },
                            invetiagation: (id) => {
                                investigationIncidentAction([{ id }]);
                            },
                            approve: (id) => {
                                approveIncidentAction([{ id }]);
                            },
                            complete: (id) => {
                                completeIncidentAction([{ id }]);
                            },
                            notify: (id) => {
                                notifyIncidentAction([{ id }]);
                            },
                            delete: (id) => {
                                setShowConfirmModal({
                                    title: 'Delete the incident',
                                    question: `Are you sure you want to remove the incident?`,
                                    confirmAction: () => {
                                        deleteIncidentAction([{ id }]);
                                    },
                                });
                            }
                        } : {
                            selectedRows: state.selectedRows,
                            viewIncident: id => {
                                props.history.push(`/maintain/incidents/edit?id=${id}`);
                            },
                            invetiagation: (id) => {
                                investigationIncidentAction([{ id }]);
                            },
                            approve: (id) => {
                                approveIncidentAction([{ id }]);
                            },
                            notify: (id) => {
                                notifyIncidentAction([{ id }]);
                            },
                        }
                    }
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains(
                                "col-row-selector"
                            )
                        ) {
                            return;
                        }
                        props.history.push(`/maintain/incidents/edit?id=${this.props.rowData.id}`);
                    }}
                    setSelectedRows={setSelectedRows(["id"], setSelectedIncidentIds)}
                    filters={filters || {}}
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    IncidentTypesReducer: state.IncidentTypesReducer,
    IncidentsReducer: state.IncidentsReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
    AffiliatesReducer: state.AffiliatesReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadIncidentTypesAction,
    loadIncidentsAction,
    approveIncidentAction,
    setPaginationAction,
    investigationIncidentAction,
    completeIncidentAction,
    notifyIncidentAction,
    deleteIncidentAction,
    loadAffiliatesAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Incidents);
